import { render, staticRenderFns } from "./recipient.vue?vue&type=template&id=341d24c6&"
import script from "./recipient.vue?vue&type=script&lang=js&"
export * from "./recipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports